<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.99822 0L15.7252 7.1326C16.0597 7.44132 15.8412 8 15.3861 8H13.3307V16H10V11.167C10 10.8909 9.77614 10.667 9.5 10.667H6.5C6.22386 10.667 6 10.8909 6 11.167V16H2.66406V8H0.610382C0.155227 8 -0.0632087 7.44132 0.271241 7.1326L7.99822 0Z"
  />
</template>
